export enum DxGridToolbarActionType {
  REFRESH = "REFRESH",
  SAVE = "SAVE",
  ADD = "ADD",
  COPY = "COPY",
  EDIT = "EDIT",
  REMOVE = "REMOVE",
  FLUSH_FILTERS = "FLUSH_FILTERS",
  XLSX_EXPORT = "XLSX_EXPORT",
  PDF_EXPORT = "PDF_EXPORT"
}
